export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_SINGLE_TEMPLATE = 'GET_SINGLE_TEMPLATE'
export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES'
